/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingQualityDomainData
 */
export interface TrackingQualityDomainData {
    /**
     * 
     * @type {string}
     * @memberof TrackingQualityDomainData
     */
    domainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackingQualityDomainData
     */
    domainEnabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    entryEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    updateEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    orderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    pairedOrderEvents?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    uniqueVisitors?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingQualityDomainData
     */
    uniqueOrderingVisitors?: number;
}

/**
 * Check if a given object implements the TrackingQualityDomainData interface.
 */
export function instanceOfTrackingQualityDomainData(value: object): value is TrackingQualityDomainData {
    return true;
}

export function TrackingQualityDomainDataFromJSON(json: any): TrackingQualityDomainData {
    return TrackingQualityDomainDataFromJSONTyped(json, false);
}

export function TrackingQualityDomainDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingQualityDomainData {
    if (json == null) {
        return json;
    }
    return {
        
        'domainName': json['domainName'] == null ? undefined : json['domainName'],
        'domainEnabled': json['domainEnabled'] === undefined ? undefined : json['domainEnabled'] === null ? null : json['domainEnabled'],
        'entryEvents': json['entryEvents'] == null ? undefined : json['entryEvents'],
        'updateEvents': json['updateEvents'] == null ? undefined : json['updateEvents'],
        'orderEvents': json['orderEvents'] == null ? undefined : json['orderEvents'],
        'pairedOrderEvents': json['pairedOrderEvents'] == null ? undefined : json['pairedOrderEvents'],
        'uniqueVisitors': json['uniqueVisitors'] == null ? undefined : json['uniqueVisitors'],
        'uniqueOrderingVisitors': json['uniqueOrderingVisitors'] == null ? undefined : json['uniqueOrderingVisitors'],
    };
}

export function TrackingQualityDomainDataToJSON(json: any): TrackingQualityDomainData {
    return TrackingQualityDomainDataToJSONTyped(json, false);
}

export function TrackingQualityDomainDataToJSONTyped(value?: TrackingQualityDomainData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domainName': value['domainName'],
        'domainEnabled': value['domainEnabled'],
        'entryEvents': value['entryEvents'],
        'updateEvents': value['updateEvents'],
        'orderEvents': value['orderEvents'],
        'pairedOrderEvents': value['pairedOrderEvents'],
        'uniqueVisitors': value['uniqueVisitors'],
        'uniqueOrderingVisitors': value['uniqueOrderingVisitors'],
    };
}

